/** Balearic + recovery surcharge helpers (mirrors backend/client_invoicing/geo.py). */

const BALEARIC_RE =
  /balear|illes\s*balears?|mallorca|menorca|ibiza|eivissa|formentera|\b07[0-8]\d{3}\b/i;

const RECOVERY_CONTINENTAL = 'Tarifa de Recuperación - Europa Continental y Reino Unido';
const RECOVERY_ISLANDS = 'Tarifa de Recuperación - Islas Europeas';
const RECOVERY_CEUTA = 'Tarifa de Recuperación - Ceuta y Melilla';
const BALEARIC_NAME = 'Illes Balears';

export function isBalearicAddress(pickup = '', delivery = '', pickupLat, pickupLng, deliveryLat, deliveryLng) {
  const blob = `${pickup} ${delivery}`;
  if (BALEARIC_RE.test(blob)) return true;
  for (const [lat, lng] of [
    [pickupLat, pickupLng],
    [deliveryLat, deliveryLng],
  ]) {
    if (lat != null && lng != null && lat >= 38.5 && lat <= 40.2 && lng >= 1.0 && lng <= 4.5) {
      return true;
    }
  }
  return false;
}

export function recoveryZoneFromAddresses(pickup = '', delivery = '') {
  const blob = `${pickup} ${delivery}`.toLowerCase();
  if (/ceuta|melilla|51001|52001/.test(blob)) return 'ceuta_melilla';
  if (/canarias|tenerife|lanzarote|fuerteventura|balear|illes balears|mallorca|menorca|ibiza|formentera/.test(blob)) {
    return 'islands';
  }
  if (/\buk\b|united kingdom|reino unido|england|london/.test(blob)) return 'continental';
  return 'continental';
}

export function recoveryServiceName(zone) {
  if (zone === 'ceuta_melilla') return RECOVERY_CEUTA;
  if (zone === 'islands') return RECOVERY_ISLANDS;
  return RECOVERY_CONTINENTAL;
}

export function findServiceIdByName(services, name) {
  const exact = services.find((s) => s.name === name);
  if (exact) return exact.id;
  const partial = services.find((s) => s.name?.toLowerCase().includes(name.slice(0, 15).toLowerCase()));
  return partial?.id;
}

export function mergeGeoSurcharges({
  selectedIds,
  additionalServices,
  pickupAddress,
  deliveryAddress,
  pickupLat,
  pickupLng,
  deliveryLat,
  deliveryLng,
  isRecoveryService,
}) {
  let ids = [...selectedIds];
  const locked = [];

  if (isBalearicAddress(pickupAddress, deliveryAddress, pickupLat, pickupLng, deliveryLat, deliveryLng)) {
    const bid = findServiceIdByName(additionalServices, BALEARIC_NAME);
    if (bid && !ids.includes(bid)) ids.push(bid);
    if (bid) locked.push(bid);
  }

  if (isRecoveryService) {
    const zone = recoveryZoneFromAddresses(pickupAddress, deliveryAddress);
    const rname = recoveryServiceName(zone);
    [RECOVERY_CONTINENTAL, RECOVERY_ISLANDS, RECOVERY_CEUTA].forEach((n) => {
      const rid = findServiceIdByName(additionalServices, n);
      if (rid) ids = ids.filter((x) => x !== rid);
    });
    const rid = findServiceIdByName(additionalServices, rname);
    if (rid && !ids.includes(rid)) ids.push(rid);
    if (rid) locked.push(rid);
  } else {
    [RECOVERY_CONTINENTAL, RECOVERY_ISLANDS, RECOVERY_CEUTA].forEach((n) => {
      const rid = findServiceIdByName(additionalServices, n);
      if (rid) ids = ids.filter((x) => x !== rid);
    });
  }

  return { selectedIds: ids, lockedIds: locked };
}

export { BALEARIC_NAME, RECOVERY_CONTINENTAL, RECOVERY_ISLANDS, RECOVERY_CEUTA };
